<template>
  <div id="manager">
    <p class="top">
      <span>{{ companyName }}</span>
      <logout />
    </p>
    <div class="left">
      <el-menu :default-active="activeIndex"
               class="layout-menu"
               background-color="#f0f9eb"
               active-text-color="#FFF"
               text-color="#333"
               @select="handleSelect">
        <el-menu-item v-for="(item, index) in MenuList"
                      :key="index"
                      :index="index.toString()">
          <p slot="title">{{ item.title }}</p>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <div class="main">
        <el-scrollbar style="height:100%">
          <router-view @changeCompanyName="changeCompanyName" />
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import logout from '@/components/common/logout'
import { mapGetters } from 'vuex'
export default {
  name: 'manager',
  components: {
    logout,
  },
  data () {
    return {
      activeIndex: '0',
      MenuList: [],
    }
  },
  computed: {
    ...mapGetters(['companyName']),
  },
  mounted () {
    this.getRouterList()
  },
  methods: {
    handleSelect (_index) {
      let _path = this.MenuList[_index]
      if (_path.path == this.$route.path) {
        return
      }
      this.activeIndex = _index
      this.$router.push(_path.path)
    },
    getRouterList () {
      let routerList = JSON.parse(sessionStorage.getItem('managerRouter'))
      this.MenuList = routerList.map((item) => {
        let obj = { path: '/manager/' + item.menu_path, title: item.menu_name }
        return obj
      })
      this.changePath()
    },
    changePath () {
      let _path = this.$route.path
      for (let i in this.MenuList) {
        if (_path == this.MenuList[i].path) {
          this.activeIndex = i
          this.activeName = this.MenuList[i].title
          break
        }
      }
    },
    changeCompanyName (_name) {
      this.companyName = _name
    },
  },
  watch: {
    $route (to, from) {
      this.changePath()
    },
  },
}
</script>

<style lang="less" scoped>
#manager {
  position: relative;
  padding: 50px 0 0 150px;
  height: 100%;
  /deep/ .el-dialog__body {
    padding: 10px 20px;
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
  }
  .top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #eee;
    line-height: 50px;
    padding: 0 20px;
  }
  .left {
    position: absolute;
    top: 50px;
    left: 0;
    width: 150px;
    height: calc(100% - 50px);
    background: #f0f9eb;
  }
  .el-menu {
    border: 0;
    /deep/ .el-menu-item.is-active {
      background-color: #67c23a !important;
    }
  }
  .right {
    background: #eee;
    padding: 8px;
    height: 100%;
    .main {
      height: 100%;
      overflow: hidden;
      /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
  }
}
</style>
